import React from 'react';

import gTKMascot from '@/src/assets/img/mascots/gTK/grade-TK-mascot.png';
import gKMascot from '@/src/assets/img/mascots/gK/grade-K-mascot.png';
import g1Mascot from '@/src/assets/img/mascots/g1/grade-1-mascot.png';
import g2Mascot from '@/src/assets/img/mascots/g2/grade-2-mascot.png';
import g3Mascot from '@/src/assets/img/mascots/g3/grade-3-mascot.png';
import g4Mascot from '@/src/assets/img/mascots/g4/grade-4-mascot.png';
import g5Mascot from '@/src/assets/img/mascots/g5/grade-5-mascot.png';
import g6Mascot from '@/src/assets/img/mascots/g6/grade-6-mascot.png';
import g6MMascot from '@/src/assets/img/mascots/g6M/grade-6M-mascot.png';
import g7Mascot from '@/src/assets/img/mascots/g7/Grade-7-mascot.png';
import g8Mascot from '@/src/assets/img/mascots/g8/Grade-8-mascot.png';

import gTKHero from '@/src/assets/img/mascots/gTK/grade-TK-hero.jpg';
import gKHero from '@/src/assets/img/mascots/gK/grade-K-hero.jpg';
import g1Hero from '@/src/assets/img/mascots/g1/grade-1-hero.jpg';
import g2Hero from '@/src/assets/img/mascots/g2/grade-2-hero.jpg';
import g3Hero from '@/src/assets/img/mascots/g3/grade-3-hero.jpg';
import g4Hero from '@/src/assets/img/mascots/g4/grade-4-hero.jpg';
import g5Hero from '@/src/assets/img/mascots/g5/grade-5-hero.jpg';
import g6Hero from '@/src/assets/img/mascots/g6/grade-6-hero.jpg';
import g6MHero from '@/src/assets/img/mascots/g6M/grade-6M-hero.jpg';
import g7Hero from '@/src/assets/img/mascots/g7/grade-7-hero.jpg';
import g8Hero from '@/src/assets/img/mascots/g8/Grade-8-hero.jpg';

interface SubheaderProps {
    title: string;
    grade: string;
    type: 'default' | 'hero';
}
const Subheader: React.FC<SubheaderProps> = ({ title, grade, type = 'default' }) => {
    if (type === 'default') {
        return (
            <header className="pd-header">
                <div className="pd-primary background" id="headerBanner">
                    <h1 id="headerBanner-text">{title}</h1>
                </div>
            </header>
        );
    } else {
        return (
            <header className="pd-header">
                <div
                    id="lessonHeaderBanner"
                    className={`background pd-G${grade}-primary`}
                    style={{ display: 'flex', width: '100%', position: 'relative' }}
                >
                    <img
                        id="cornerImage"
                        src={getCornerImage(grade)}
                        alt="Grade Banner Corner"
                        className={`banner-image corner ${getCornerImageClass(grade)} pd-G${grade}-primary background`}
                    />

                    <img
                        id="bannerImage"
                        src={getBannerImage(grade)}
                        alt="Grade Banner"
                        className={`banner-image banner ${['6M', '7', '8'].includes(grade.toUpperCase()) ? 'MS' : ''}`}
                    />

                    <h1 id="gradeTitle">{title}</h1>
                </div>
            </header>
        );
    }
};

export default Subheader;

function getCornerImageClass(grade: string) {
    switch (grade) {
        case 'TK':
        case 'K':
        case '1':
        case '2':
            return 'hero';
        case '6M':
        case '7':
        case '8':
            return 'pattern';
        default:
            return '';
    }
}

function getCornerImage(grade: string) {
    switch (grade) {
        case 'TK':
            return gTKMascot;
        case 'K':
            return gKMascot;
        case '1':
            return g1Mascot;
        case '2':
            return g2Mascot;
        case '3':
            return g3Mascot;
        case '4':
            return g4Mascot;
        case '5':
            return g5Mascot;
        case '6':
            return g6Mascot;
        case '6M':
            return g6MMascot;
        case '7':
            return g7Mascot;
        case '8':
            return g8Mascot;
        default:
            return gTKMascot;
    }
}

function getBannerImage(grade: string) {
    switch (grade) {
        case 'TK':
            return gTKHero;
        case 'K':
            return gKHero;
        case '1':
            return g1Hero;
        case '2':
            return g2Hero;
        case '3':
            return g3Hero;
        case '4':
            return g4Hero;
        case '5':
            return g5Hero;
        case '6':
            return g6Hero;
        case '6M':
            return g6MHero;
        case '7':
            return g7Hero;
        case '8':
            return g8Hero;
        default:
            return gTKHero;
    }
}
